import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getHomeroomTeacherTermFromUser } from "../utils/homeroomTeacherTerm";

/** Primary → "class teacher"; secondary → "form teacher". */
export function useHomeroomTeacherTerm() {
    const { currentUser } = useSelector((state) => state.user);
    return useMemo(
        () => getHomeroomTeacherTermFromUser(currentUser),
        [currentUser],
    );
}
